const MILLISECONDS_PER_SECOND = 1000;

export const formatDurationSeconds = (milliseconds: number): string =>
	`${(milliseconds / MILLISECONDS_PER_SECOND).toFixed(1)}s`;
